import '../../index.css';
var styles = {
  "textArea": "bp_text_area_autosize_module_textArea--bb063",
  "error": "bp_text_area_autosize_module_error--bb063",
  "loading": "bp_text_area_autosize_module_loading--bb063",
  "loadingIndicator": "bp_text_area_autosize_module_loadingIndicator--bb063",
  "border": "bp_text_area_autosize_module_border--bb063"
};
export { styles as default };